<template>
  <div style="position: relative; width: 100%; height: 100%;">
    <canvas id="schedule-chart"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js/auto';

export default {
  name: 'schedule-chart',
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      chartObj: null,
      scheduleChartData: {
        type: 'bar',
        data: {
          labels: [],
          datasets: [
            {
              type: 'bar',
              label: 'Turno Mañana',
              data: [],
              backgroundColor: '#00B0FF',
              borderRadius: 4,
              yAxisID: 'y',
            },
            {
              type: 'bar',
              label: 'Turno Tarde',
              data: [],
              backgroundColor: '#FFEB3B',
              borderRadius: 4,
              yAxisID: 'y',
            },
            {
              type: 'bar',
              label: 'Turno Noche',
              data: [],
              backgroundColor: '#FF4081',
              borderRadius: 4,
              yAxisID: 'y',
            },
            {
              type: 'line',
              label: 'Ausencias',
              data: [],
              borderColor: '#03fc73',
              borderWidth: 2,
              tension: 0.3,
              fill: false,
              yAxisID: 'y1',
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'top',
              labels: {
                boxWidth: 12,
                color: '#666666',
              },
            },
            tooltip: {
              mode: 'index',
              intersect: false,
            },
          },
          scales: {
            x: {
              ticks: { color: '#666666' },
              grid: { display: false },
            },
            y: {
              type: 'linear',
              display: true,
              position: 'left',
              beginAtZero: true,
              ticks: {
                color: '#666666',
                precision: 0,
              },
              grid: { color: 'rgba(0, 0, 0, 0.1)' },
            },
            y1: {
              type: 'linear',
              display: true,
              position: 'right',
              beginAtZero: true,
              ticks: {
                precision: 0,
                color: '#666666',
              },
              grid: {
                drawOnChartArea: false,
              },
            },
          },
        },
      },
    };
  },

  mounted() {
    this.applyThemeToChart();
    const ctx = document.getElementById('schedule-chart');
    if (ctx) {
      // eslint-disable-next-line no-new
      this.chartObj = new Chart(ctx, this.scheduleChartData);
    } else {
      console.error('Canvas element #schedule-chart not found on mount');
    }
  },

  watch: {
    chartData: {
      handler(newVal) {
        if (!newVal) return;
        this.$nextTick(() => {
          this.updateChartData(newVal);
        });
      },
      deep: true,
      immediate: true,
    },
    '$vuetify.theme.dark': {
      handler() {
        if (this.chartObj) {
          this.applyThemeToChart();
          this.chartObj.update();
        }
      },
    },
  },

  methods: {
    hexToRgba(hex, alpha) {
      if (!hex || !hex.startsWith('#')) return `rgba(128, 128, 128, ${alpha})`;
      const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      const fullHex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
      if (!result) return `rgba(128, 128, 128, ${alpha})`;
      const r = parseInt(result[1], 16);
      const g = parseInt(result[2], 16);
      const b = parseInt(result[3], 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    applyThemeToChart() {
      const isDark = this.$vuetify.theme.dark;

      const morningColor = '#00B0FF';
      const eveningColor = '#FFEB3B';
      const nightColor = '#FF4081';
      const absenceColor = '#03fc73';

      const textColor = isDark ? '#e0e0e0' : '#666666';
      const gridColor = isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)';

      // Colors for datasets
      this.scheduleChartData.data.datasets[0].backgroundColor = morningColor;
      this.scheduleChartData.data.datasets[1].backgroundColor = eveningColor;
      this.scheduleChartData.data.datasets[2].backgroundColor = nightColor;
      this.scheduleChartData.data.datasets[3].borderColor = absenceColor;

      // Colors for options
      this.scheduleChartData.options.plugins.legend.labels.color = textColor;
      this.scheduleChartData.options.scales.x.ticks.color = textColor;
      this.scheduleChartData.options.scales.y.ticks.color = textColor;
      this.scheduleChartData.options.scales.y.grid.color = gridColor;
      this.scheduleChartData.options.scales.y1.ticks.color = textColor;
    },
    updateChartData(temporalData) {
      if (!this.chartObj) {
        return;
      }
      if (!temporalData || temporalData.length === 0) {
        this.chartObj.data.labels = [];
        this.chartObj.data.datasets[0].data = [];
        this.chartObj.data.datasets[1].data = [];
        this.chartObj.data.datasets[2].data = [];
        this.chartObj.data.datasets[3].data = [];
        this.chartObj.update();
        return;
      }

      const labels = temporalData.map((d) => d.monthName);
      const morningCounts = temporalData.map((d) => d.morningCount);
      const eveningCounts = temporalData.map((d) => d.eveningCount);
      const nightCounts = temporalData.map((d) => d.nightCount);
      const absenceCounts = temporalData.map((d) => d.absenceCount);

      this.chartObj.data.labels = labels;
      this.chartObj.data.datasets[0].data = morningCounts;
      this.chartObj.data.datasets[1].data = eveningCounts;
      this.chartObj.data.datasets[2].data = nightCounts;
      this.chartObj.data.datasets[3].data = absenceCounts;

      this.chartObj.update();
    },
  },
};
</script>
